module.exports = __webpack_public_path__ + "img/trial3-3.8cd2fa66.png";